/**
 * This behavior is for the Find-A-Physician Registry Form.
 */

'use strict';
(function ($, Drupal, once) {

  Drupal.behaviors.findAPhysicianRegistry = {
    attach: (context, settings) => {
      const proceduresSelector = '.js-procedures';
      const updateSelector = '#edit-is-this-a-new-submission-or-an-update-to-an-existing-submission-2';

      // Show the message when user clicks on update option in below question:
      // Is this a new submission or an update to an existing submission?
      $(once('#edit-is-this-a-new-submission-or-an-update-to-an-existing-submission-2', updateSelector, context)).each(function () {
        $(this).on('click', function() {
          alert(Drupal.t('Please complete all required fields and use the comment box to indicate updates'));
        });
      });

      // Show all procedures chosen when user choose "No" option in procedures list.
      $(proceduresSelector, context).find('.form-radio').each(function() {
        var $this = $(this);
        if (!$this.data('processed')) {
          $this.data('processed', true);
          $this.click(function(e) {
            var $this = $(e.currentTarget);
      
            // Show only user choose "No"
            if (String($this.closest('.option').text()).toLowerCase() == 'no') {
              Drupal.behaviors.findAPhysicianRegistry.showMessage(context);
            }
          });
        }
      });
      
    },

    /**
     * Get All Procedures Checked
     * @returns {object}
     */
    getAllProceduresChecked: (context) => {
      const proceduresSelector = '.js-procedures';

      let procedureName = '',
          result = { 'yes': [], 'no': [] },
          options = $(proceduresSelector, context).find('.form-radio:checked').closest('.option');

      // Get all procedures checked and separate in Yes or No
      for (let i = 0, l = options.length; i < l; i++) {

        procedureName = $(options[i]).closest('.js-form-wrapper').prev().find('.control-label').text();

        if (String($(options[i]).text()).toLowerCase() == 'yes') {
          result['yes'].push(procedureName);
          continue;
        }

        result['no'].push(procedureName);
      }

      return result;
    },

    /**
     * Show procedures chosen by user.
     */
    showMessage: (context) => {
      let message = '',
          procedures = Drupal.behaviors.findAPhysicianRegistry.getAllProceduresChecked(context);

      // YES message.
      if (procedures['yes'].length > 0) {
        message = `${Drupal.t('These are the procedures you have selected YES for:')}\n`;
        message += `${procedures['yes'].join('\n')}\n\n`;
      }

      message += `${Drupal.t('These are the procedures you have selected NO for:')}\n`;
      message += `${procedures['no'].join('\n')}`;

      alert(message);
    }
  };

})(jQuery, Drupal, once);
